/**
 * Canonical product attribute IDs shared across all domain registries:
 * Catalog: Filters, Sorting, DataItems (List columns/Card/Tile), 
 * Product: Summary,
 * Favorites: CompareRows,
 * Hero/Tiers: Color Modes
 */
export const PRODUCT_ATTRIBUTE_IDS = {

	ACTIONS:            'actions',
    ADDITIONAL_AREAS:   'additional_areas',
	AREA:               'area',         // → p.area_original
	BUILDING:           'building_id',
    CATEGORY:           'category',     // → p.product_category
	COMPARE_AREA:		'compare_area',
    EXPOSITION:         'exposition',
    EXPOSITION_SIDES:   'exposition_sides',
    EXTERNAL_AREAS:     'external_areas',
    FAVORITES:          'favorites',
	GATE:               'gate',
	ID_CAD:             'id_cad',
    INSOLATION:			'insolation',
    INSOLATION_HOURS:   'insolation_hours',
    INSOLATION_RANGE:   'insolation_range',
	INQUIRY:            'inquiry',
	INVESTMENT:         'investment_id',
    OFFER:              'offer',
	PRICE:              'price',        // → resolvePrice(p)
	ROOMS:              'rooms',
	STATUS:             'status',
	TIERS:              'tiers',        // → p.ref_tier
    SPECIAL_AREAS:      'special_areas',
}

export const PRODUCT_ACTION_IDS = {
	FAVORITES:		PRODUCT_ATTRIBUTE_IDS.FAVORITES,
	FLOOR_PLAN:		'floor_plan',
	INQUIRY:		PRODUCT_ATTRIBUTE_IDS.INQUIRY,
}